import * as React from 'react';
import type { SVGProps } from 'react';

const SvgIm = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={23} height={21} viewBox="0 0 48 48" {...props} fill={"currentColor"} fillRule={"evenodd"} stroke={"transparent"}>
    <path
      d="M34.831 42.393H11.178a6.571 6.571 0 0 1-6.57-6.571V12.169a6.571 6.571 0 0 1 6.57-6.569h23.653a6.571 6.571 0 0 1 6.57 6.571v23.652a6.57 6.57 0 0 1-6.57 6.57ZM11.587 16.677a1.965 1.965 0 1 0-3.93 0v13.8a1.965 1.965 0 1 0 3.93 0v-13.8Zm6.393.006a1.971 1.971 0 0 0-1.971-1.971 1.971 1.971 0 0 0-1.971 1.971V30.47a1.971 1.971 0 0 0 1.971 1.971 1.971 1.971 0 0 0 1.971-1.971V16.683Zm-3.54-1.562a1.956 1.956 0 0 1 2.764-.166l12.663 13.963a1.96 1.96 0 0 1-2.6 2.936L14.606 17.89a1.964 1.964 0 0 1-.165-2.77Zm8.728 0a1.956 1.956 0 0 1 2.764-.166L38.6 28.918a1.96 1.96 0 0 1-2.6 2.936L23.335 17.89a1.964 1.964 0 0 1-.166-2.77Z"
    />
  </svg>
);

export default SvgIm;
